import { FC } from 'react'
import { IconProps } from './ClimatIcon'

const InventoryIcon: FC<IconProps> = ({ selected }) => {
	const color = selected ? '#fff' : '#3894EB'
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect x="2" y="3" width="8" height="8" rx="1.5" fill={color} />
			<rect x="14" y="3" width="8" height="8" rx="1.5" fill={color} />
			<rect x="2" y="13" width="8" height="8" rx="1.5" fill={color} />
			<rect
				x="14"
				y="13"
				width="8"
				height="8"
				rx="1.5"
				fill={color}
				opacity="0.5"
			/>
			<line
				x1="16"
				y1="17"
				x2="22"
				y2="17"
				stroke={selected ? '#fff' : '#364F69'}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<line
				x1="19"
				y1="14"
				x2="19"
				y2="20"
				stroke={selected ? '#fff' : '#364F69'}
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	)
}

export default InventoryIcon
